/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ReverseTransactionRequest} from '@cash-web/protos/squareup/banklin/ledger_service.pb'
import {ReverseTransactionResponse} from '@cash-web/protos/squareup/banklin/ledger_service.pb'


export const reverseTransaction = (request: ReverseTransactionRequest, options?: CashRequestOptions) => post<ReverseTransactionRequest, ReverseTransactionResponse>("/2.0/cash/reverse-transaction", request, {...options, rejectOnError: true })